import { render, staticRenderFns } from "./TopUpsTable.vue?vue&type=template&id=2a780f85&scoped=true&"
import script from "./TopUpsTable.vue?vue&type=script&lang=js&"
export * from "./TopUpsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a780f85",
  null
  
)

export default component.exports